import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
export var OwFGrantApplicationSteps;
(function(OwFGrantApplicationSteps) {
    OwFGrantApplicationSteps["UPSELL"] = "UPSELL";
    // store details steps
    OwFGrantApplicationSteps["STORE_DETAILS_INTRO"] = "STORE_DETAILS_INTRO";
    // financial details steps
    OwFGrantApplicationSteps["FINANCIAL_DETAILS_INTRO"] = "FINANCIAL_DETAILS_INTRO";
    OwFGrantApplicationSteps["STORE_FUNDING_DETAILS"] = "STORE_FUNDING_DETAILS";
    OwFGrantApplicationSteps["CREDIT_HISTORY_DETAILS"] = "CREDIT_HISTORY_DETAILS";
    // video upload steps
    OwFGrantApplicationSteps["VIDEO_UPLOAD_INTRO"] = "VIDEO_UPLOAD_INTRO";
    OwFGrantApplicationSteps["UPLOAD_VIDEO"] = "UPLOAD_VIDEO";
    OwFGrantApplicationSteps["REVIEW_VIDEO"] = "REVIEW_VIDEO";
    OwFGrantApplicationSteps["PROCESS_VIDEO"] = "PROCESS_VIDEO";
    // terminal steps
    OwFGrantApplicationSteps["INELIGIBLE_STORE"] = "INELIGIBLE_STORE";
    OwFGrantApplicationSteps["APPLICATION_SUCCESS"] = "APPLICATION_SUCCESS";
})(OwFGrantApplicationSteps || (OwFGrantApplicationSteps = {}));
var OwFGrantLandingPageSections;
(function(OwFGrantLandingPageSections) {
    OwFGrantLandingPageSections["HEADER_CARD"] = "HEADER_CARD";
    OwFGrantLandingPageSections["DISCLAIMER_CARD"] = "DISCLAIMER_CARD";
    OwFGrantLandingPageSections["APPLICATION_INFO_CARD"] = "APPLICATION_INFO_CARD";
    OwFGrantLandingPageSections["KEY_DATES_CARD"] = "KEY_DATES_CARD";
    OwFGrantLandingPageSections["PAST_WINNERS_CARD"] = "PAST_WINNERS_CARD";
    OwFGrantLandingPageSections["LEARN_MORE_CARD"] = "LEARN_MORE_CARD";
    OwFGrantLandingPageSections["FAQ_CARD"] = "FAQ_CARD";
    OwFGrantLandingPageSections["FOOTER_CARD"] = "FOOTER_CARD";
})(OwFGrantLandingPageSections || (OwFGrantLandingPageSections = {}));
var OtherOwFGrantSurfaces;
(function(OtherOwFGrantSurfaces) {
    OtherOwFGrantSurfaces["SIGN_UP_SOCIAL_MEDIA"] = "SIGN_UP_SOCIAL_MEDIA";
})(OtherOwFGrantSurfaces || (OtherOwFGrantSurfaces = {}));
export var OwFGrantFlowPages = _object_spread({}, OwFGrantLandingPageSections, OwFGrantApplicationSteps, OtherOwFGrantSurfaces);
export var OwFGrantCtas;
(function(OwFGrantCtas) {
    OwFGrantCtas["APPLY_NOW"] = "APPLY_NOW";
    OwFGrantCtas["GET_STARTED"] = "GET_STARTED";
    OwFGrantCtas["NEXT"] = "NEXT";
    OwFGrantCtas["SUBMIT_APPLICATION"] = "SUBMIT_APPLICATION";
    OwFGrantCtas["EXPLORE_FAIRE"] = "EXPLORE_FAIRE";
})(OwFGrantCtas || (OwFGrantCtas = {}));
export var OwFGrantUserFlows;
(function(OwFGrantUserFlows) {
    OwFGrantUserFlows["LOGGED_OUT_FLOW"] = "LOGGED_OUT_FLOW";
    OwFGrantUserFlows["LOGGED_IN_FLOW"] = "LOGGED_IN_FLOW";
    OwFGrantUserFlows["LOGGED_IN_APPLIED_TO_OWF_FLOW"] = "LOGGED_IN_APPLIED_TO_OWF_FLOW";
})(OwFGrantUserFlows || (OwFGrantUserFlows = {}));
